<template>
  <div
    ref="root"
    class="ui-dialog-content modal-content rounded-4 overflow-hidden"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
import { onClickOutside } from "@vueuse/core";
import { ref } from "vue";
import { useUIDialogContext } from "./UIDialogRoot.vue";

const root = ref<HTMLElement>();
const dialog = useUIDialogContext();

onClickOutside(root, () => dialog?.dismiss());
</script>
